export const LANDING = '/';
export const DISCOUNTS_VIEWER = '/discount';